import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './components/App';
//import Header from './components/Header';
import Footer from './components/Footer';
import * as serviceWorker from './serviceWorker';


ReactDOM.render(
  <React.StrictMode>
  { /* <Header />*/}
    <App />
    <Footer />
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.unregister();
